import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { HttpService } from 'src/app/core/services/http.service';

@Component({
  selector: 'bulk-app-payment-id-field',
  templateUrl: './bulk-payment-id-field.component.html',
  styleUrls: ['./bulk-payment-id-field.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class BulkPaymentIdFieldComponent implements OnInit, OnDestroy {
  @Input() fromFile: boolean = false;
  @Input() label: string = 'Payment ID';
  @Input() controlName: string = 'payment_id';
  @Input('required') isRequired = false;
  form: FormGroup;
  private previousValue: string = '';
  // paymentIdRegex = /^[0-9,]*$/;

  constructor(private ctrlContainer: FormGroupDirective, private http: HttpService) {}

  ngOnInit(): void {
    this.form = this.ctrlContainer.form;
    this.form.addControl(
      this.controlName,
      new FormControl('')
    );
    this.form.controls[this.controlName].valueChanges.subscribe((val: any) => {
      if (val == null) {
        this.form.controls[this.controlName].setValue('', { emitEvent: false });
      }

      if (!/^[\d,]*$/.test(val)) {
        // If not valid, revert to previous value
        this.form.controls[this.controlName].setValue(this.previousValue, { emitEvent: false });
        return;
      }

      this.previousValue = val;
    });
  }

  ngOnDestroy(): void {
    this.form.removeControl('payment_id');
  }

  onPaymentIdCsvUpload(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  const url = '/services/api/v1/payout/ei-codes'; // Use your actual endpoint
  this.http.post(url, formData).subscribe((res: any) => {
    if (res) {
      this.form.controls[this.controlName].patchValue(res);
    }
  });
}

  transformValue(): void {
    const currentValue = this.form.controls['payment_id'].value;
    if (currentValue) {
      const transformed = currentValue
        .split(',')
        .map((v: string) => v.trim())
        .filter((v: string) => v !== '')
        .map((v: string) => Number(v))
        .filter((n: number) => !isNaN(n));
      
      this.form.controls['payment_id'].setValue(transformed, { emitEvent: false });
    }
  }
}
